<section id="quick-links" class="py-5 my-4 bg-dark position-relative overflow-hidden">
  <!-- Subtle premium background overlay -->
  <div class="bg-bookshelf-overlay"></div>

  <div class="container-fluid px-3 px-lg-5 position-relative" style="z-index: 2;">
    <div class="text-center mb-5">
      <h2 class="ql-title text-white text-uppercase fw-bold mb-2">Quick Links</h2>
      <p class="lead text-orange small text-uppercase fw-semibold tracking-wider">Explore Life & Opportunities @ SSJGC
      </p>
    </div>

    <div class="ql-grid">

      <!-- Row 1 -->
      <a routerLink="/about-us/principal-message" class="ql-card">
        <div class="ql-img-wrapper">
          <img src="assets/img/message/principal.jpg" alt="Meet the Principal">
        </div>
        <div class="ql-caption text-uppercase fw-bold">Meet the Principal</div>
      </a>

      <a routerLink="/campus-overview" class="ql-card">
        <div class="ql-img-wrapper">
          <img src="assets/img/quick-links/campus.jpg" alt="Campus Overview">
        </div>
        <div class="ql-caption text-uppercase fw-bold">Campus Overview</div>
      </a>

      <a routerLink="/latest-in-college" class="ql-card">
        <div class="ql-img-wrapper">
          <img src="assets/img/quick-links/latest.jpg" alt="Latest in College">
        </div>
        <div class="ql-caption text-uppercase fw-bold">Latest in College</div>
      </a>

      <a routerLink="/student-facilities/sports" class="ql-card">
        <div class="ql-img-wrapper">
          <img src="assets/img/quick-links/sports-main.jpg" alt="Sports">
        </div>
        <div class="ql-caption text-uppercase fw-bold">Sports</div>
      </a>

      <!-- Row 2 -->
      <a routerLink="/student-facilities/culture-music" class="ql-card">
        <div class="ql-img-wrapper">
          <img src="assets/img/quick-links/culture.jpg" alt="Cultural Activities">
        </div>
        <div class="ql-caption text-uppercase fw-bold">Cultural Activities</div>
      </a>

      <a routerLink="/campus-life/nss" class="ql-card">
        <div class="ql-img-wrapper">
          <img src="assets/img/quick-links/nss-main.jpg" alt="NSS">
        </div>
        <div class="ql-caption text-uppercase fw-bold">NSS</div>
      </a>

      <a routerLink="/campus-life/ncc" class="ql-card">
        <div class="ql-img-wrapper">
          <img src="assets/img/quick-links/ncc-main.jpg" alt="NCC">
        </div>
        <div class="ql-caption text-uppercase fw-bold">NCC</div>
      </a>

      <a routerLink="/campus-life/youth-red-cross" class="ql-card">
        <div class="ql-img-wrapper">
          <img src="assets/img/quick-links/yrc-main.jpg" alt="Youth Red Cross">
        </div>
        <div class="ql-caption text-uppercase fw-bold">Youth Red Cross (YRC)</div>
      </a>

      <!-- Row 3 -->
      <a routerLink="/seminars-and-workshops" class="ql-card">
        <div class="ql-img-wrapper">
          <img src="assets/img/quick-links/seminar.jpg" alt="Seminars/Conferences">
        </div>
        <div class="ql-caption text-uppercase fw-bold">Seminars/Conferences</div>
      </a>

      <a routerLink="/college-in-news" class="ql-card">
        <div class="ql-img-wrapper">
          <img src="assets/img/quick-links/news-main.jpg" alt="College in News">
        </div>
        <div class="ql-caption text-uppercase fw-bold">College in News</div>
      </a>

      <a routerLink="/safety-security" class="ql-card">
        <div class="ql-img-wrapper">
          <img src="assets/img/quick-links/security.jpg" alt="Safety and Security">
        </div>
        <div class="ql-caption text-uppercase fw-bold">Safety and Security</div>
      </a>

      <a routerLink="/e-resource-development-cell" class="ql-card">
        <div class="ql-img-wrapper">
          <img src="assets/img/quick-links/resource.jpg" alt="E-Resource Development Cell">
        </div>
        <div class="ql-caption text-uppercase fw-bold">E-Resource Development Cell</div>
      </a>

      <!-- Row 4 -->
      <a routerLink="/iqac/best-prac/go-green-initiative" class="ql-card">
        <div class="ql-img-wrapper">
          <img src="assets/img/quick-links/green.jpg" alt="Go Green">
        </div>
        <div class="ql-caption text-uppercase fw-bold">Go Green</div>
      </a>

      <a routerLink="/financial-support-and-welfare-works" class="ql-card">
        <div class="ql-img-wrapper">
          <img src="assets/img/quick-links/financial.jpg" alt="Financial Support/Welfare Works">
        </div>
        <div class="ql-caption text-uppercase fw-bold">Financial Support/Welfare Works</div>
      </a>

      <a routerLink="/placements" class="ql-card">
        <div class="ql-img-wrapper">
          <img src="assets/img/quick-links/placement.jpg" alt="Placement Cell">
        </div>
        <div class="ql-caption text-uppercase fw-bold">Placement Cell</div>
      </a>

      <a routerLink="/educational-trips" class="ql-card">
        <div class="ql-img-wrapper">
          <img src="assets/img/quick-links/trip.jpg" alt="Educational Trips">
        </div>
        <div class="ql-caption text-uppercase fw-bold">Educational Trips</div>
      </a>

      <!-- Row 5 -->
      <a routerLink="/awards" class="ql-card">
        <div class="ql-img-wrapper">
          <img src="assets/img/quick-links/award.jpg" alt="Awards">
        </div>
        <div class="ql-caption text-uppercase fw-bold">Awards</div>
      </a>

      <a routerLink="/library/about-library" class="ql-card">
        <div class="ql-img-wrapper">
          <img src="assets/img/quick-links/library.jpg" alt="Library">
        </div>
        <div class="ql-caption text-uppercase fw-bold">Library</div>
      </a>

      <a routerLink="/youth-festival" class="ql-card">
        <div class="ql-img-wrapper">
          <img src="assets/img/quick-links/youth-festival-img.jpg" alt="Youth Festival">
        </div>
        <div class="ql-caption text-uppercase fw-bold">Youth Festival</div>
      </a>

      <a routerLink="/girl-guides-and-scouts" class="ql-card">
        <div class="ql-img-wrapper">
          <img src="assets/img/quick-links/girls.jpg" alt="Girl Guides and Scouts">
        </div>
        <div class="ql-caption text-uppercase fw-bold">Girl Guides and Scouts</div>
      </a>

      <!-- Row 6 -->
      <a routerLink="/world-record" class="ql-card">
        <div class="ql-img-wrapper">
          <img src="assets/img/quick-links/world_record.jpg" alt="World Record">
        </div>
        <div class="ql-caption text-uppercase fw-bold">World Record</div>
      </a>

      <a routerLink="/athletic-meet" class="ql-card">
        <div class="ql-img-wrapper">
          <img src="assets/img/quick-links/Athletic-Meet_img2-711x400.jpg" alt="Athletic Meet">
        </div>
        <div class="ql-caption text-uppercase fw-bold">Athletic Meet</div>
      </a>

      <a routerLink="/summer-sports-camp" class="ql-card">
        <div class="ql-img-wrapper">
          <img src="assets/img/quick-links/summar_sports_camp-711x400.jpg" alt="summer Sports Camp">
        </div>
        <div class="ql-caption text-uppercase fw-bold">summer Sports Camp</div>
      </a>

      <a routerLink="/campus-life/campus-facilities" class="ql-card">
        <div class="ql-img-wrapper">
          <img src="assets/img/quick-links/Labs3-533x400.jpg" alt="Facilities In Campus">
        </div>
        <div class="ql-caption text-uppercase fw-bold">Facilities In Campus</div>
      </a>

    </div>
  </div>
</section>